import React from 'react';
import styled from 'styled-components';

import useSettingItem from '@/hooks/useSettingItem';

function Note() {
  const creditCalculationText = useSettingItem('СREDIT_CALCULATION_TEXT');

  return <Component>{creditCalculationText}</Component>;
}

export default Note;

const Component = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin-top: 15px;
  color: ${(props) => props.theme.black200_alpha40};
`;
